import { render, staticRenderFns } from "./contactHighlight.vue?vue&type=template&id=24476cc7&"
import script from "./contactHighlight.vue?vue&type=script&lang=js&"
export * from "./contactHighlight.vue?vue&type=script&lang=js&"
import style0 from "./contactHighlight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports